import React from "react";

const PosTerminalIcon = ({ classname, height = 24, width = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 36"
      height={24}
      width={24}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classname}>
      {/* Main body of the terminal */}
      <rect x="4" y="8" width="16" height="24" rx="2" />
      {/* Screen */}
      <rect x="6" y="10" width="12" height="8" />
      {/* Keypad buttons (simplified as a grid) */}
      <rect x="6" y="20" width="3" height="3" />
      <rect x="10" y="20" width="3" height="3" />
      <rect x="14" y="20" width="3" height="3" />
      <rect x="6" y="24" width="3" height="3" />
      <rect x="10" y="24" width="3" height="3" />
      <rect x="14" y="24" width="3" height="3" />
      <rect x="6" y="28" width="3" height="3" />
      <rect x="10" y="28" width="3" height="3" />
      <rect x="14" y="28" width="3" height="3" />
      {/* Paper receipt slot */}
      <rect x="8" y="2" width="8" height="6" />
      <line x1="8" y1="4" x2="16" y2="4" />
    </svg>
  );
};

export default PosTerminalIcon;
